import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DoubleArrow, Check, Clear, Add, Save,
} from '@mui/icons-material';
import { LinearProgress, Stack } from '@mui/material';
import { toaster } from 'evergreen-ui';
import Select from '../ui/Select';
import materials, { popOver } from '../../assets/templates';
import validateRequiredFields, { toInteger } from '../../utilities';
import UserMaterials from '../../api/materials';

const SelectMaterialView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
}) => {
  // const [isChecked, setIsChecked] = useState(false);
  const [isNextStepAvailable, setIsNextStepAvailable] = useState(false);
  const [validateSubmit, setValidateSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState({ elementIndex: null, status: false });
  const [userStoredMaterials, setUserStoredMaterials] = useState([]);
  const [materialsList, setMaterialsList] = useState([]);
  const [count, setCount] = useState(0);
  const id = localStorage.getItem('id');
  const element = useRef();

  /**
   * Calcula el numero de piezas por material y su costo
   */
  useEffect(() => {
    const mockValues = [...calculationsData.material.values];
    const newValues = mockValues.map((material) => {
      if (material?.length && material?.width && material?.cost) {
        const quantity = (material.length
          * material.width)
          / (Number(calculationsData.machine.lengthCut
          * calculationsData.machine.witdhCut)
          );
        const elementValues = {
          ...material,
          totalPiecesPerSheet: quantity < 1 ? 1 : quantity,
          costPerPiece: quantity <= 1
            ? material.cost
            : material.cost / quantity,
          pieceArea: (material.length
          * material.width),
        };
        return elementValues;
      }
      return material;
    });
    setCalculationsData({
      ...calculationsData,
      material: {
        ...calculationsData.material,
        costPerPiece: newValues.reduce((previousValue, currentValue) => previousValue + currentValue.costPerPiece, 0),
        values: newValues,
      },
    });
    if (isNextStepAvailable) return;
    setIsNextStepAvailable(true);
  }, [JSON.stringify(calculationsData.material.values)]);

  const handleCreateNewMaterial = async (data, index) => {
    if (!data.name || !data.cost || !data.length || !data.width || !data.thickness) {
      toaster.warning('Faltan datos por llenar', {
        id: 'forbidden-action',
        duration: 1.5,
      });
      return;
    }
    setIsLoading({ elementIndex: index, status: true });
    UserMaterials.createMaterial({ ...data, currency: calculationsData.currentCurrency.currencyCode }, id)
      .then((response) => {
        if (response.id) {
          toaster.success('Material guardado', {
            id: 'forbidden-action',
            duration: 1,
          });
          setCount(count + 1);
          setIsLoading({ elementIndex: null, status: false });
          return;
        }
        toaster.danger('Algo salio mal, vuelva interalo pronto', {
          id: 'forbidden-action',
          duration: 1.5,
        });
        setIsLoading({ elementIndex: null, status: false });
      })
      .catch((err) => {
        console.log(err);
        toaster.danger('Algo salio mal, vuelva interalo pronto', {
          id: 'forbidden-action',
          duration: 1.5,
        });
        setIsLoading({ elementIndex: null, status: false });
      });
  };

  const getArray = async (opcion) => {
    if (opcion === 'Materiales predeterminados') return [...materials];
    if (opcion === 'Mis materiales') return [...userStoredMaterials];
    if (opcion === 'Todos los materiales') return [...materials, ...userStoredMaterials];
    return [...materials];
  };

  useEffect(async () => {
    const newMaterials = await UserMaterials.getMaterialsByUser(id);

    const materialsOptions = ['Nuevo material', 'Materiales predeterminados'];
    if (newMaterials.length > 0) {
      setUserStoredMaterials(newMaterials);
      materialsOptions.push('Mis materiales');
      materialsOptions.push('Todos los materiales');
    }
    setMaterialsList(materialsOptions);
  }, [count]);

  useEffect(() => {
    setValidateSubmit(validateRequiredFields(document.querySelectorAll('[required]')));
  }, [calculationsData.material]);

  return (
    <form
      ref={element}
      onSubmit={(e) => {
        e.preventDefault();
        setView(view + 1);
      }}
      className="main-container"
      style={{ position: 'relative' }}
    >

      <button
        onClick={() => setView(view - 1)}
        id="button"
        className="simple-button"
        type="button"
        style={{
          position: 'absolute', top: '0', left: '0',
        }}
      >
        <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
        Paso anterior
      </button>

      {isNextStepAvailable
      && (
        <button
          id="button"
          className="simple-button"
          type="submit"
          data-available={validateSubmit}
          data-disabled={!validateSubmit}
          style={{
            position: 'absolute', top: '0', right: '0',
          }}
        >
          <DoubleArrow />
          Siguiente paso
        </button>
      )}

      <ul style={{ padding: '0' }}>
        {React.Children.toArray(calculationsData.material.values.map((material, index) => (
          <li
            className={`
              aligned-items item-container appear ${isLoading.elementIndex === index && 'item-container-border'}
            `}
            style={{ position: 'relative' }}
          >
            {isLoading.elementIndex === index
            && (
            <Stack
              sx={{
                width: '100%', color: 'grey.500', position: 'absolute', top: '0', left: '0',
              }}
              spacing={2}
            >
              <LinearProgress style={{ borderRadius: '35px 35px 0 0', height: '7px' }} color="inherit" />
            </Stack>
            )}
            <div className="icon-wrapper" style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="justify-items">
                  <p className="mr-t-0 inline-block">
                    {(calculationsData?.material.values[0]?.name
                      && calculationsData?.material.values[0]?.cost > 0)
                      && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
                    Seleccione el tipo de material a utilizar
                  </p>
                  <div data-title={popOver[20]}>
                    <img
                      alt="icon"
                      src={`https://ramonsgt.github.io/calculadora-de-inversion-sagaon/
assets/icons/question-mark.svg`}
                    />
                  </div>
                </div>
                <div
                  className="icon-wrapper justify-items"
                  style={{ width: 'auto', margin: '0' }}
                >
                  {calculationsData.material.values?.length > 1
                    && (
                      <button
                        style={{ marginRight: '20px' }}
                        className="simple-button delete-button"
                        type="button"
                        data-title={popOver[46]}
                        disabled={isLoading.elementIndex === index}
                        onClick={() => {
                          const newArray = calculationsData.material.values.filter((item, materialIndex) => (
                            materialIndex !== index));
                          setCalculationsData({
                            ...calculationsData,
                            material: {
                              ...calculationsData.material,
                              values: newArray,
                            },
                          });
                        }}
                      >
                        <Clear style={{ fontSize: '15px', alignItems: 'center', verticalAlign: 'middle' }} />
                      </button>
                    )}
                  <button
                    disabled={material.materialType === 'Mis materiales' || isLoading.status}
                    onClick={() => handleCreateNewMaterial(material, index)}
                    type="button"
                    className="simple-button delete-button"
                    data-title="Guardar"
                  >
                    <Save style={{ fontSize: '20px', alignItems: 'center', verticalAlign: 'middle' }} />
                  </button>
                </div>
              </div>
              <div className="aligned-items" style={{ justifyContent: 'space-between' }}>
                <p>Materiales</p>
                <Select
                  value={material?.materialType || ''}
                  setValue={async (value) => {
                    const mockData = [...calculationsData.material.values];
                    mockData[index].materialType = value;
                    const array = await getArray(value);
                    mockData[index].options = array;
                    if (value === 'Nuevo material') {
                      mockData[index].name = '';
                      mockData[index].cost = 0;
                      mockData[index].width = 0;
                      mockData[index].length = 0;
                      mockData[index].thickness = 0;
                    }
                    setCalculationsData(({
                      ...calculationsData,
                      material: {
                        ...calculationsData.material,
                        materialType: value,
                        values: mockData,
                      },
                    }));
                  }}
                  options={materialsList}
                  placeholder="Selecciona una opcion"
                  required
                />
              </div>
              {material.materialType !== 'Nuevo material'
                ? (
                  <Select
                    value={material?.name || ''}
                    setValue={(value) => {
                      const [selectedValue] = material.options.filter((item) => item.name === value);
                      const mockValues = [...calculationsData.material.values];
                      mockValues[index].name = selectedValue.name;
                      mockValues[index].cost = selectedValue?.cost || 0;
                      mockValues[index].width = selectedValue?.width || 0;
                      mockValues[index].length = selectedValue?.length || 0;
                      mockValues[index].thickness = selectedValue?.thickness || 0;
                      setCalculationsData(({
                        ...calculationsData,
                        material: {
                          ...calculationsData.material,
                          values: mockValues,
                        },
                      }));
                    }}
                    options={material.options}
                    property="name"
                    placeholder="Selecciona una opcion"
                    required
                  />
                )
                : (
                  <input
                    type="text"
                    placeholder="Escriba el nombre del material"
                    value={material.name}
                    onChange={(e) => {
                      const mockValues = [...calculationsData.material.values];
                      mockValues[index].name = e.target.value;
                      setCalculationsData(({
                        ...calculationsData,
                        material: {
                          ...calculationsData.material,
                          values: mockValues,
                        },
                      }));
                    }}
                  />
                )}
              {material.name
                && (
                <div className="icon-wrapper appear">
                  <div className="aligned-items">
                    <div style={{ marginRight: 'auto', width: '100%' }}>
                      <p>Costo total de la hoja</p>
                      <div data-title={popOver[21]}>
                        <img
                          alt="icon"
                          src={`https://ramonsgt.github.io/calculadora-de-inversion-sagaon/
assets/icons/question-mark.svg`}
                        />
                      </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <input
                        type="number"
                        value={toInteger(material?.cost, 2) || ''}
                        onChange={(e) => {
                          setCalculationsData({
                            ...calculationsData,
                            material: {
                              ...calculationsData.material,
                              values: calculationsData.material.values.map((item, materialIndex) => (
                                materialIndex === index ? { ...item, cost: Number(e.target.value) } : item)),
                            },
                          });
                        }}
                        required
                      />
                      <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
                    </div>
                  </div>
                </div>
                )}

              {(material.cost > 0 && material.name)
                && (
                <div className="appear">
                  <p style={{ margin: '50px 0 20px 0' }}>
                    {(material?.width > 0 && material?.length > 0 && material?.thickness > 0)
                    && (
                    <Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
                    Especifique las medidas del material a utilizar
                  </p>

                  <div className="material-measures" style={{ display: 'flex' }}>
                    <div className="icon-wrapper">
                      <p>Alto del material</p>
                      <div data-title={popOver[22]}>
                        <img
                          alt="icon"
                          src={`https://ramonsgt.github.io/calculadora-de-inversion-sagaon/
assets/icons/question-mark.svg`}
                        />
                      </div>
                      <div style={{ position: 'relative' }}>
                        <input
                          type="number"
                          value={material.width || ''}
                          onChange={(e) => {
                            if (e.target.value > calculationsData.machine.lengthCut) {
                              // toaster.warning(`El alto maximo de tu area de trabajo es de
                              // ${calculationsData.machine.lengthCut}cm`, {
                              //   id: 'forbidden-action',
                              //   duration: 1.5,
                              // });
                            }
                            return setCalculationsData({
                              ...calculationsData,
                              material: {
                                ...calculationsData.material,
                                values: calculationsData.material.values.map((item, materialIndex) => (
                                  materialIndex === index ? { ...item, width: Number(e.target.value) } : item)),
                              },
                            });
                          }}
                          required
                        />
                        <p className="end-input-icon">cm</p>
                      </div>
                    </div>
                    <div className="icon-wrapper">
                      <p>Largo del material</p>
                      <div data-title={popOver[23]}>
                        <img
                          alt="icon"
                          src={`https://ramonsgt.github.io/calculadora-de-inversion-sagaon/
assets/icons/question-mark.svg`}
                        />
                      </div>
                      <div style={{ position: 'relative' }}>
                        <input
                          type="number"
                          value={material.length || ''}
                          onChange={(e) => {
                            if (e.target.value > calculationsData.machine.witdhCut) {
                              // toaster.warning(`El largo maximo de tu area de trabajo es de
                              // ${calculationsData.machine.witdhCut}cm`, {
                              //   id: 'forbidden-action',
                              //   duration: 1.5,
                              // });
                            }
                            setCalculationsData({
                              ...calculationsData,
                              material: {
                                ...calculationsData.material,
                                values: calculationsData.material.values.map((item, materialIndex) => (
                                  materialIndex === index ? { ...item, length: Number(e.target.value) } : item)),
                              },
                            });
                          }}
                          required
                        />
                        <p className="end-input-icon">cm</p>
                      </div>
                    </div>
                    <div className="icon-wrapper">
                      <p>Grosor del material</p>
                      <div style={{ position: 'relative' }}>
                        <input
                          type="number"
                          value={material?.thickness || ''}
                          onChange={(e) => {
                            if (e.target.value > calculationsData.machine.witdhCut) {
                              // toaster.warning(`El ancho maximo de tu area de trabajo es de
                              // ${calculationsData.machine.witdhCut}cm`, {
                              //   id: 'forbidden-action',
                              //   duration: 1.5,
                              // });
                            }
                            setCalculationsData({
                              ...calculationsData,
                              material: {
                                ...calculationsData.material,
                                values: calculationsData.material.values.map((item, materialIndex) => (
                                  materialIndex === index ? { ...item, thickness: Number(e.target.value) } : item)),
                              },
                            });
                          }}
                          required
                        />
                        <p className="end-input-icon">mm</p>
                      </div>
                    </div>
                  </div>
                </div>
                )}

              {material.costPerPiece > 0 && material.totalPiecesPerSheet > 0
              && (
              <div
                className="appear item-container-contrast mr-t-0"
                style={{ margin: '50px auto 0 auto', backgroundColor: 'transparent' }}
              >
                <div className="aligned-items icon-wrapper">
                  <div className="icon-wrapper">
                    <p>Numero de piezas</p>
                    <div data-title={popOver[1]}>
                      <img
                        alt="icon"
                        src={`https://ramonsgt.github.io/calculadora-de-
inversion-sagaon/assets/icons/question-mark.svg`}
                      />
                    </div>
                  </div>
                  <div className="icon-wrapper-checkbox" style={{ position: 'relative' }}>
                    {/* <input
                      id="checkbox-parsefloat"
                      data-title="redondear numero de piezas"
                      type="checkbox"
                      readOnly
                      style={{
                        width: '20px',
                        height: '20px',
                        position: 'absolute',
                        top: '4px',
                        marginLeft: 'calc(100% - 30px)',
                      }}
                      value={isChecked}
                      onClick={() => {
                        // if (!isChecked) {
                        //   setCalculationsData({
                        //     ...calculationsData,
                        //     material: {
                        //       ...calculationsData.material,
                        //       prevStateTotalPiecesPerSheet: calculationsData.material.totalPiecesPerSheet,
                        //       totalPiecesPerSheet: Math.floor(calculationsData?.material?.totalPiecesPerSheet),
                        //       costPerPiece: ((calculationsData?.material?.fullMaterialCost || 0)
                        //       / Math.floor(calculationsData.material.totalPiecesPerSheet)),
                        //     },
                        //   });
                        // } else {
                        //   setCalculationsData({
                        //     ...calculationsData,
                        //     material: {
                        //       ...calculationsData.material,
                        //       totalPiecesPerSheet: calculationsData.material.prevStateTotalPiecesPerSheet,
                        //       costPerPiece: ((calculationsData?.material?.fullMaterialCost || 0)
                        //       / calculationsData.material.prevStateTotalPiecesPerSheet),
                        //     },
                        //   });
                        // }
                        setIsChecked(!isChecked);
                      }}
                    />
                    */}
                    <input
                      className="select"
                      type="number"
                      required
                      readOnly
                      placeholder="0"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity('El numero de diseños debe ser mayor a 0');
                        } else {
                          e.target.setCustomValidity('');
                        }
                      }}
                      value={toInteger(material.totalPiecesPerSheet, 2) || ''}
                    />
                  </div>
                </div>
                <div className="aligned-items">
                  <div className="icon-wrapper">
                    <p>{`Costo de ${material.name} por pieza`}</p>
                    <div data-title={popOver[24]}>
                      <img
                        alt="icon"
                        src={`https://ramonsgt.github.io/calculadora-de-inversion-sagaon/
assets/icons/question-mark.svg`}
                      />
                    </div>
                  </div>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <input
                      placeholder="0"
                      className="select"
                      type="number"
                      required
                      readOnly
                      data-disabled="true"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity('El costo por diseño debe ser mayor a 0');
                        } else {
                          e.target.setCustomValidity('');
                        }
                      }}
                      value={toInteger(material?.costPerPiece, 2)}
                    />
                    <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
                  </div>
                </div>
              </div>
              )}
            </div>
          </li>
        )))}
      </ul>

      <div className="box-container" style={{ maxWidth: '600px', margin: 'auto' }}>
        <div className="icon-wrapper item-container add-box">
          <p>Agregar Material</p>
          <button
            style={{ width: '30px', height: '30px' }}
            onClick={() => {
              const mockMaterials = [...calculationsData.material.values];
              mockMaterials.push({
                name: '', cost: 0, width: 0, length: 0, thickness: 0, isUsingSavedMaterial: false,
              });
              setCalculationsData({
                ...calculationsData,
                material: {
                  ...calculationsData.material,
                  values: mockMaterials,
                },
              });
            }}
            type="button"
            className="simple-button"
            // data-title={popOver[47]}
          >
            <Add style={{ fontSize: '20px', alignItems: 'center', verticalAlign: 'middle' }} />
          </button>
        </div>
      </div>

      {calculationsData.material.values.every((material) => (
        (material.cost > 0 && material.width > 0 && material.length > 0 && material.thickness > 0)
        || (material.totalPiecesPerSheet > 0 && material.costPerPiece >= 0)))
      && (
      <div className="appear item-container-contrast mr-t-0">
        <div className="aligned-items">
          <div className="icon-wrapper">
            <p>Costo total del material</p>
            <div data-title={popOver[24]}>
              <img
                alt="icon"
                src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
              />
            </div>
          </div>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              placeholder="0"
              className="select"
              type="number"
              required
              readOnly
              data-disabled="true"
              onInvalid={(e) => {
                if (!e.target.value) {
                  e.target.setCustomValidity('El costo por diseño debe ser mayor a 0');
                } else {
                  e.target.setCustomValidity('');
                }
              }}
              value={toInteger(calculationsData.material?.costPerPiece, 2)}
            />
            <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
          </div>
        </div>
      </div>
      )}
    </form>
  );
};

SelectMaterialView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    machine: PropTypes.shape({
      id: PropTypes.string,
      lengthCut: PropTypes.number,
      name: PropTypes.string,
      productModel: PropTypes.string,
      shopifyPrice: PropTypes.number,
      url: PropTypes.string,
      witdhCut: PropTypes.number,
    }),
    material: PropTypes.shape({
      values: PropTypes.arrayOf(PropTypes.shape({
        isUsingSavedMaterial: PropTypes.bool,
        name: PropTypes.string,
        cost: PropTypes.number,
        width: PropTypes.number,
        length: PropTypes.number,
        thickness: PropTypes.number,
      })),
      costPerPiece: PropTypes.number,
      materialName: PropTypes.string,
      pieceArea: PropTypes.number,
      prevStateTotalPiecesPerSheet: PropTypes.number,
      totalPiecesPerSheet: PropTypes.number,
    }),
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectMaterialView);
